


















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Debounced } from '@/utils/debounced';
import { requestGetSolutions } from '@/utils/solution';

type ISolutionInfo = ISolution.IResponse.ISolutionInfo;
type ISearchSolution = ISolution.IRequest.ISearchSolution;

@Component
export default class SearchQuotation extends Vue {
  @Prop({default: () => ({})}) private readonly search!: ISearchSolution;
  private fetching: boolean = false;
  private quotationOptions: ISolutionInfo[] = [];
  private debouncedFetchQuotation: (
    searchVal: string,
  ) => void = new Debounced().use(this.searchQuotation, 1000); // 节流函数

  public searchQuotationById(quotationId: string) {
    this.fetching = true;
    requestGetSolutions({
      id: quotationId,
    }).then((res) => {
      this.fetching = false;
      this.quotationOptions = res.data;
    }).catch((err) => {
      this.fetching = false;
      this.$message.warning(err);
    });
  }
  // 触发搜索需求方法
  private fetchQuotation(searchVal: string) {
    this.debouncedFetchQuotation(searchVal);
  }
  // 请求需求数据
  private searchQuotation(searchVal: string) {
    this.fetching = true;
    const searchTxt = searchVal.trim();
    const params: ISearchSolution = {};
    if (searchTxt) {
      params.title = searchTxt;
    }
    Object.assign(params, this.search);
    requestGetSolutions(params).then((res) => {
      this.fetching = false;
      this.quotationOptions = res.data;
    }).catch((err) => {
      this.fetching = false;
      this.$message.warning(err);
    });
  }
  // 处理选项改变
  private handleChange(value: string) {
    const quotationInfo = this.quotationOptions.find((option) => option.id === value) || null;
    this.$emit('change', quotationInfo);
  }
}
